import { render, staticRenderFns } from "./AccountCharacters.vue?vue&type=template&id=7ad846af&scoped=true&"
import script from "./AccountCharacters.vue?vue&type=script&lang=js&"
export * from "./AccountCharacters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad846af",
  null
  
)

export default component.exports